export const isObject = (o) => {
  return !!o && o.constructor === Object;
};

export const localToObject = (o) => {
  if (!isObject(o)) {
    return {};
  }
  return o;
};

export const isObjectEmpty = (o) => {
  return Object.keys(localToObject(o)).length === 0;
};

export const containsObject = (obj, list) => {
  let i;
  for (i = 0; i < list.length; i++) {
    if (JSON.stringify(list[i]) === JSON.stringify(obj)) {
      return true;
    }
  }

  return false;
};

export const getValueOrSuggestion = (suggestionObject, value) => {
  if (suggestionObject?.codigo === value || suggestionObject?.descripcion === value) {
    return suggestionObject;
  } else {
    return { codigo : null, descripcion: value };
  }
};

export function jwtToObject(jwt) {
  try {
      // Divide el token en sus 3 partes
      const parts = jwt.split('.');
      if (parts.length !== 3) {
          throw new Error('JWT mal formado');
      }

      // Toma la parte del cuerpo/payload
      const payloadBase64 = parts[1];
      // Decodifica el base64
      const decodedPayload = atob(payloadBase64);
      
      // Convierte la cadena JSON decodificada en un objeto
      return JSON.parse(decodedPayload);
  } catch (error) {
      return null;
  }
}
